import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {PriceDto} from '../../domain/priceDto';
import {ChargeRecordPowerDto} from '../../domain/chargeRecord/chargeRecordPowerDto';
import {ChargeRecordDto} from '../../domain/chargeRecord/chargeRecordDto';

@Injectable({
    providedIn: 'root'
})
export class FrontChargeRecordHttpService {
    private http: HttpClient;

    constructor(http: HttpClient) {
        this.http = http;
    }

    public byIdAndOtpCode(id: string, otpCode: string) {
        return this.http.get<ChargeRecordDto>(`/front/chargeRecords/${id}/otp/${otpCode}`);
    }

    public computePrice(id: string): Observable<PriceDto> {
        return this.http.get<PriceDto>(`/v2/front/chargeRecords/${id}/price`);
    }
    public computePower(id: string): Observable<ChargeRecordPowerDto> {
        return this.http.get<ChargeRecordPowerDto>(`/v2/front/chargeRecords/${id}/power`);
    }
}

export enum ChargeRecordLazyCategory {
    PRICING = 'PRICING',
    SMART_CHARGING_EVENTS = 'SMART_CHARGING_EVENTS'
}
